import axios from "axios";
import { rutas } from "../rutas/rutas";
import { getCookie } from "../utils/getCookies";

export const recolectarSevice = async (id) => {
  const token = getCookie("token");

  return axios({
    url: rutas.recolectar,
    data: { id },
    method: "post",
    headers: {
      token,
    },
    // Evita que la interfaz quede esperando indefinidamente si una dependencia
    // externa o el servidor se bloquea. El backend ya hace fallback del bonus.
    timeout: 15000,
  });
};
